import type { Contact } from 'bundles/backoffice/contacts/types';

function buildConfig(
  label: string,
  key: string,
  getter: string | ((contact: Contact) => string | null | undefined),
) {
  return {
    label,
    key,
    getValue: (contact: Contact) => typeof getter === 'string' ? contact[getter] : getter(contact),
  };
}

const commonAttributes = [
  buildConfig('Email', 'email', 'email'),
  buildConfig('Phone', 'phone_numbers', 'phoneFormatted'),
  buildConfig('Address', 'addresses', 'addressFormatted'),
];

export const SHARABLE_PERSON_ATTRIBUTES = [
  ...commonAttributes,
  buildConfig(
    'Businesses', 'businesses',
    (contact: Contact) => {
      if (contact.businessRecords) {
        const business = contact.businessRecords[0]?.business;
        return business?.name || business?.email;
      }
    },
  ),
  buildConfig('Job Title', 'job_title', 'jobTitle'),
  buildConfig('License Number', 'license_number', 'licenseNumber'),
];

export const SHARABLE_BUSINESS_ATTRIBUTES = [
  ...commonAttributes,
  buildConfig('Website', 'website', 'website'),
];
  
export function getSharableAttributes(contact: Contact) {
  const sharableAttributes = contact.isPerson ? SHARABLE_PERSON_ATTRIBUTES : SHARABLE_BUSINESS_ATTRIBUTES;
  return sharableAttributes.filter(attr => attr.getValue(contact));
}
